import React, { useEffect } from "react";
import {Container,Grid,InputLabel ,FormControl,Select,MenuItem} from '@material-ui/core';
import Nepalmap from '../../../assets/images/election_voter_count.png';
// import Voterlist from "../VoterList";
import { useDispatch, useSelector } from "react-redux";
import Branch from "../../../models/branch.model";
import { fetchBranch } from "../../../services/branchs.service";
import {Link} from 'react-router-dom';
import { lang } from "../../../config/app.config";
import translate from '../../../translation.json';
import { TranslationState } from "../../../store/ActionReducers/translation.actionreducer";

interface state{
  branch:{
    branches:Array<Branch>,
    loadingBranch:boolean
  },
  translation:TranslationState
}

const LinksOptions:React.FC = () =>{

  const dispatch = useDispatch();

  // redux state

  const state = useSelector((state:state)=>{
    return state;
  });
  const {branch,translation:trans} = state;
  const {branches,loadingBranch} = branch;

  useEffect(()=>{
    if(!branches) dispatch(fetchBranch());
  },[dispatch]) //eslint-disable-line


  return(
    <div className="section-break-2">
      <Container maxWidth="lg">
        <Grid container spacing={2} className="d-flex align-item-center">
          {/* //options */}
          <Grid item xs={12} lg={4} md={6} xl={4}>
            {/* <Voterlist/> */}
            <div className="section-padding-1 bg-primary br-6px">
              <h3 className="text-18">
                <Link to={`/${lang}/election-offices`} className="text-dark">{trans.translation?trans.translation.state_election_offices[lang === 'np'?'value_np':'value_en']:''}
                </Link>
                </h3>
              <p className='text-13-black'>
              {trans.translation?trans.translation.state_election_offices_text[lang === 'np'?'value_np':'value_en']:''}</p>
              <FormControl variant="outlined" className="custom-select mt-1">
                <InputLabel id="district">{translate.translation[lang].province}</InputLabel>
                <Select
                  labelId={translate.translation[lang].province}
                  id={translate.translation[lang].province}
                  label={translate.translation[lang].province}
                  className="box-shadow-input"
                >
                  {!loadingBranch?
                    branches && branches.length?
                      branches.map(b=>{
                        if(!b.district){
                          return (
                            <Link to={`/${lang}/province/${b.slug}`} key={b.id} className="text-black" target="_blank"> 
                              <MenuItem  >
                                {b.province}
                              </MenuItem>
                            </Link>
                          );
                        }
                        return "";
                      })
                    :<MenuItem value='' disabled>No branches</MenuItem>
                    :<MenuItem value='' disabled>Loading</MenuItem>
                  }
                  
                </Select>
              </FormControl>
            </div>
          </Grid>
          {/* // map of nepal */}
          <Grid item xs={12} lg={4} md={6} xl={4}>
            <div className="map-wrapper">
              <img src={Nepalmap} alt="" className="img-fluid"/>
            </div>
          </Grid>

          {/* links to officaial site */}
          <Grid item xs={12} lg={4} md={6} xl={4} className="">
            <div className="section-padding-1 bg-primary br-6px">
              <h3 className="text-18">
              <Link to={`/${lang}/election-offices`} className="text-dark">
                {trans.translation?trans.translation.state_district_election_offices[lang === 'np'?'value_np':'value_en']:''}
                </Link>
                </h3>
              <p className='text-13-black'>
              {trans.translation?trans.translation.state_district_election_offices_text[lang === 'np'?'value_np':'value_en']:''}</p>
              <FormControl variant="outlined" className="custom-select mt-1">
                <InputLabel id="district">{translate.translation[lang].districts}</InputLabel>
                <Select
                  labelId={translate.translation[lang].districts}
                  id={translate.translation[lang].districts}
                  label={translate.translation[lang].districts}
                  className="box-shadow-input"
                >
                  {!loadingBranch?
                    branches && branches.length?
                      branches.map(b=>{
                        if(b.district){
                          return (
                            <Link to={`/${lang}/district/${b.slug}`} key={b.id} className="text-dark" target="_blank"> 
                              <MenuItem  >
                                {b.district}
                              </MenuItem>
                            </Link>
                          );
                        }
                        return "";
                      })
                    :<MenuItem value='' disabled>No branches</MenuItem>
                    :<MenuItem value='' disabled>Loading</MenuItem>
                  }
                  
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}


export default LinksOptions;
